import React, { useEffect, useState } from "react";
import { DateRangePicker, DateRange } from "react-date-range";
import {  setDateRange } from "../../../redux/action";
import { RootState } from "../../../redux/reducer";
import { connect, ConnectedProps } from "react-redux";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import { addDays, format } from "date-fns";
import { vi } from "date-fns/locale";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, InputAdornment, TextField } from "@mui/material";
import { DateRangeOutlined } from "@mui/icons-material";

type PropsFromRedux = ConnectedProps<typeof connector>;
type DatePickerProps = PropsFromRedux & {};

const CustomDateRangePicker: React.FC<DatePickerProps> = ({
  dateRange,
  setDateRange,
  ...rest

}) => {
   
    const [isShowCalendar, setIshowCalendar] = React.useState(false); 

    const handleInputDateChange = (item: any) => {
        setDateRange({ ...dateRange, ...item })
    }

    // const [dateRange, setDateRange] = useState({
    //     selection1: {
    //       startDate: addDays(new Date(), -6),
    //       endDate: new Date(),
    //       key: 'selection1'
    //     },
    //     selection2: {
    //       startDate: addDays(new Date(), 1),
    //       endDate: addDays(new Date(), 7),
    //       key: 'selection2'
    //     }
    // });

    const [dateRange1, setDateRange1] = useState(
        `${format(dateRange.selection1.startDate, "MM/dd/yyyy", {
        locale: vi
        })} - ${format(dateRange.selection1.endDate, "MM/dd/yyyy", {
        locale: vi
        })}`
    );
  
    useEffect(() => {
        setDateRange1(
            `${format(dateRange.selection1.startDate, "MM/dd/yyyy", {
                locale: vi
            })} - ${format(dateRange.selection1.endDate, "MM/dd/yyyy", {
                locale: vi
            })}`
        );
    }, [dateRange]);


    const handleClickOpenCalendar = () => {
      setIshowCalendar(true);
    };
  
    const handleClickCloseCalendar = () => {
      setIshowCalendar(false);
    };


    return (
        <div>
          <Grid container spacing={1} direction={"row"}>
            <Grid item>
            <TextField
              label ="Date Range"
              multiline
               onClick={handleClickOpenCalendar}
               value={dateRange1} 
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <IconButton>
                      <DateRangeOutlined />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            </Grid>
          
          </Grid>
          <Dialog
            open={isShowCalendar}
            onClose={handleClickCloseCalendar}
            maxWidth="md"
          >
            <DialogTitle title="Date Range Filter"></DialogTitle>
            <DialogContent>
              {isShowCalendar && (
                <div className="box-calendar">
                    <DateRangePicker
                        onChange={handleInputDateChange}
                        showPreview={true}
                        // showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        months={2}
                        editableDateInputs={true}
                        ranges={[dateRange.selection1, dateRange.selection2]}
                        direction="horizontal"
                    />
                </div>
              )}
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button onClick={handleClickCloseCalendar} color="primary">
                Done
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    };


const mapState = (state: RootState) => ({
  isUserLoggedIn: state.user.isUserLoggedIn,
  dateRange: state.report.dateRange,
});

const connector = connect(mapState, {
  setDateRange
});
    
export default connector(CustomDateRangePicker);
    
    
   